import React from "react";

export const Logo = ({ size = "md", className = "" }) => {
  const sizes = {
    sm: { wrap: "text-lg", svg: 22 },
    md: { wrap: "text-2xl", svg: 28 },
    lg: { wrap: "text-3xl md:text-4xl", svg: 36 },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div className={`flex items-center gap-2 font-heading font-extrabold ${s.wrap} ${className}`} data-testid="beecenter-logo">
      <svg width={s.svg} height={s.svg} viewBox="0 0 64 64" fill="none" aria-hidden>
        <path d="M32 6 L52 18 L52 42 L32 54 L12 42 L12 18 Z" fill="#F5A623" />
        <path d="M32 6 L52 18 L42 24 L32 18 L22 24 L12 18 Z" fill="#1A2B4A" />
        <circle cx="32" cy="32" r="6" fill="#1A2B4A" />
        <path d="M22 28 Q32 38 42 28" stroke="#1A2B4A" strokeWidth="2" fill="none" strokeLinecap="round" />
      </svg>
      <span>
        <span className="text-[#1A2B4A]">bee</span>
        <span className="text-[#F5A623]">center</span>
      </span>
    </div>
  );
};
